import React from 'react';
import { useColors } from '@osmosis/tailwind-ui/helpers/useColors';

type Props = {
  fill?: string;
  width?: string;
  height?: string;
};

/**
 * Custom svg icon for Add to playlist.
 */
const AddToPlaylistIcon = (props: Props) => {
  const { fill = 'text', width = '1em', height = '1em', ...rest } = props;
  const colors = useColors();

  return (
    <>
      <svg
        viewBox="0 0 337 337"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        xmlSpace="preserve"
        style={{
          fillRule: 'evenodd',
          clipRule: 'evenodd',
          strokeLinejoin: 'round',
          strokeMiterlimit: 2,
        }}
        fill={colors[fill] || fill}
        height={height}
        width={width}
        {...rest}
      >
        <path d="M226.215,231.44l0,-34.222c0.021,-0.928 0.01,-1.162 0.093,-2.088c0.976,-11.009 10.531,-20.731 21.972,-21.492c2.026,-0.135 2.493,-0.028 3.135,0c0.925,0.082 1.159,0.088 2.078,0.231c10.286,1.606 18.956,10.685 19.895,21.261c0.082,0.926 0.071,1.16 0.092,2.088l0,34.222l39.593,-0c0.363,0.008 0.727,0.017 1.091,0.025c11.817,0.82 21.973,10.786 22.516,22.516c0.588,12.713 -10.614,24.423 -23.607,24.724l-39.593,-0l0,34.22c-0.187,8.454 -4.813,16.562 -12.119,20.638c-8.523,4.754 -19.981,3.499 -27.275,-3.029c-4.938,-4.42 -7.723,-10.908 -7.871,-17.609l0,-34.22l-39.592,-0c-14.34,-0.332 -26.383,-14.679 -23.005,-29.044c2.414,-10.261 12.305,-17.974 23.005,-18.221l39.592,-0Zm-106.099,7.357l-96.51,0c-9.666,-0.194 -18.743,-6.407 -22.097,-15.252c-4.043,-10.66 0.895,-23.942 11.114,-29.305c3.372,-1.77 7.161,-2.63 10.983,-2.707l96.51,-0c0.317,0.006 0.635,0.012 0.952,0.019c9.649,0.584 18.469,7.157 21.464,16.129c3.511,10.515 -1.53,23.212 -11.433,28.409c-3.372,1.77 -7.161,2.63 -10.983,2.707Zm141.132,-95.008l-237.642,0c-1.319,-0.041 -1.652,-0.02 -2.962,-0.186c-9.783,-1.236 -18.378,-9.195 -20.252,-19.018c-1.667,-8.737 2.093,-18.294 9.323,-23.547c4.002,-2.908 8.894,-4.356 13.891,-4.513l237.642,-0c0.495,0.015 0.99,0.031 1.484,0.046c10.032,0.948 18.954,8.156 21.406,17.709c3.301,12.857 -6.284,27.599 -19.928,29.323c-1.31,0.166 -1.643,0.145 -2.962,0.186Zm0.702,-96.524l-238.344,-0c-1.319,-0.042 -1.652,-0.021 -2.962,-0.187c-9.783,-1.235 -18.378,-9.194 -20.252,-19.017c-1.673,-8.77 2.119,-18.314 9.323,-23.548c4.002,-2.907 8.894,-4.356 13.891,-4.513l238.344,0c0.495,0.016 0.989,0.031 1.484,0.047c1.313,0.124 1.647,0.124 2.944,0.372c12.538,2.391 21.737,16.337 18.462,29.091c-2.584,10.065 -12.366,17.424 -22.89,17.755Z" />
      </svg>
    </>
  );
};

export default AddToPlaylistIcon;
